class Location {
  constructor ({
    location,
    timeZone,
    latitude,
    longitude,
    elevation = 0.0
  } = {}) {
    this.location = location
    this.timeZone = timeZone
    this.latitude = latitude
    this.longitude = longitude
    this.elevation = elevation
  }

  get options () {
    return {
      date: new Date(),
      locationName: this.location,
      timeZoneId: this.timeZone,
      latitude: this.latitude,
      longitude: this.longitude,
      elevation: this.elevation
    }
  }
}

export const nyeCountyEast = new Location({
  location: 'Nye County (East)',
  timeZone: 'America/Los_Angeles',
  latitude: 38.417182,
  longitude: -117.622966,
  elevation: 0
})

export const nyeCountyWest = new Location({
  location: 'Nye County (West)',
  timeZone: 'America/Los_Angeles',
  latitude: 38.760675,
  longitude: -115.453167,
  elevation: 0
})

export const lakewood = new Location({
  location: 'Lakewood NJ',
  timeZone: 'America/New_York',
  latitude: 40.6782,
  longitude: -74.2097,
  elevation: 0
})

export const brooklyn = new Location({
  location: 'Brooklyn, New York',
  timeZone: 'America/New_York',
  latitude: 40.0821,
  longitude: -73.9442,
  elevation: 0
})

export const gmt = new Location({
  location: 'Greenwich',
  timeZone: 'Etc/GMT',
  latitude: 0,
  longitude: 0,
  elevation: 0
})
